<template>
  <div class="list-menu-v1-mini__container">
    <div
      :class="
        item.active
          ? darkTheme
            ? 'active '
            : 'active list-menu-v1-mini-content'
          : darkTheme
          ? ' list-menu-v1-mini-content-dark'
          : ' list-menu-v1-mini-content'
      "
      :name="item.name"
      :color="item.active ? item.color : ''"
      v-for="(item, index) in navItem"
      v-show="!item.hidden"
      @click="changeNavicationRouteItem($event, item)"
      :key="index"
      :title="$t(item.title)"
      :style="{}"
    >
      <v-tooltip
        right
        v-if="mini"
        class="item-menu-v1-mini"
        :class="
          item.active
            ? `${darkTheme ? ' active' : 'item-menu-v1 active'} `
            : `${darkTheme ? 'item-menu-v1-dark' : 'item-menu-v1'} `
        "
      >
        <template v-slot:activator="{ on }">
          <v-list-tile-action v-on="on">
            <v-icon
              :class="item.active ? 'item-menu__mini-active' : 'item-menu__mini'"
              :color="item.active ? item.color : ''"
              :style="{ backgroundColor: `${item.active} : #e6e9ec : ''` }"
            >
              {{ item.icon }}
            </v-icon>
          </v-list-tile-action>
        </template>
        <span class="tooltip-container">{{ $t(item.title) }}</span>
      </v-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  name: 'ListMenuV1Collapse',
  props: {
    navItem: {
      type: Array
    },
    mini: {
      type: Boolean
    },
    onChangeRoute: {
      type: Function
    }
  },
  methods: {
    handleOnChangeSearchTermMenu(event) {
      const searchTerm = event.target.value
      this.$emit('handleSearchMenu', searchTerm)
    },
    onChangeNavicationMini() {
      this.$emit('changeNavicationMini')
    },
    changeNavicationRouteItem($event, item) {
      this.$emit('onChangeRoute', $event, item)
    }
  },
  computed: {
    darkTheme() {
      const theme = this.$store.getters.theme
      if (!theme) return false
      return theme
    }
  }
}
</script>
<style scoped lang="scss">
.list-menu-v1-mini__container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow-y: auto;
  padding: 0 16px 48px 16px;

  &::-webkit-scrollbar {
    width: 0;
  }

  .active {
    padding: 12px 0;
    border-radius: 6px;
    background-color: #e6e9ec;
    color: #0050b3;

    a {
      padding: 0 !important;
    }
  }

  .list-menu-v1-mini-content {
    display: flex;
    padding: 12px 0;
    align-items: center;
    justify-content: center;

    .v-list__tile {
      padding: 0 !important;
    }

    &:hover {
      border-radius: 6px;
      background-color: #e6e9ec;
      cursor: pointer;
    }
  }

  .list-menu-v1-mini-content-dark {
    display: flex;
    padding: 12px 0;
    align-items: center;
    justify-content: center;

    .v-list__tile {
      padding: 0 !important;
    }

    &:hover {
      border-radius: 6px;
      background: rgba(255, 255, 255, 0.15);
      cursor: pointer;
    }
  }
}

.v-tooltip__content {
  margin-left: 2px !important;
}
</style>
